import Icon from '../components/Icon.vue'

Icon.register({
  'share-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M352 320c53 0 96 43 96 96s-43 96-96 96-96-43-96-96v0c0-5.8 1-15.1 2.3-20.8l-102.5-64.1c-16.4 13.1-37.2 20.9-59.8 20.9-53 0-96-43-96-96s43-96 96-96c22.6 0 43.4 7.8 59.8 20.9l102.5-64.1c-1.5-6.7-2.3-13.7-2.3-20.8 0-53 43-96 96-96s96 43 96 96-43 96-96 96c-22.6 0-43.4-7.8-59.8-20.9l-102.5 64.1c1.3 5.7 2.3 15 2.3 20.8 0 5.8-1 15.2-2.3 20.8l102.5 64.1c16.4-13.1 37.2-20.9 59.8-20.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/share-alt.js
// module id = 1874
// module chunks = 0